import { gql } from '@apollo/client';

export interface Input {
  id: string;
}

export interface Data {
  archiveSeason: { season: { id: string } };
}

export const MUTATION = gql`
  mutation ArchiveSeason($id: ID!) {
    archiveSeason(id: $id) {
      season {
        id
      }
    }
  }
`;
